import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import './chartWater.css';
import Content01 from "./group_content_01";
import Content02 from "./group_content_02";
import Content03 from "./group_content_03";

export default function Chart() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <div style={{ position: "relative" }}>
        <div className="chart-box-ban">
          <div className="conserve-water-chart-01-card-container">
            <div className="conserve-water-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-water-chart-01-number number-content-01">
                  {counterOn && (<CountUp start={0} end={61.8777 } decimals={2} duration={3} delay={0.3} />)}
                </div>
                <div>
                  <Content01 />
                </div>
                <div className="conserve-water-chart-01-letter letter-content-01 aa-mobile conserve-water-chart-01">
                  <h4>2022</h4>
                </div>
              </center>
            </div>

            <div className="conserve-water-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-water-chart-01-number number-content-02">
                  {counterOn && (<CountUp start={0} end={  58.3400 } decimals={2} duration={3} delay={0.3} />)}
                </div>
                <div>
                  <Content02 />
                </div>
                <div className="conserve-water-chart-01-letter letter-content-02 aa-mobile conserve-water-chart-01">
                  <h4>2023</h4>
                </div>
              </center>
            </div>

            <div className="conserve-water-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-water-chart-01-number number-content-03">
                  {counterOn && (<CountUp start={0} end={24.41} decimals={2} duration={3} delay={0.3} />)}
                </div>
                <div>
                  <Content03 />
                </div>
                <div className="conserve-water-chart-01-letter letter-content-03 aa-mobile conserve-water-chart-01">
                  <h4>Target</h4>
                </div>
              </center>
            </div>
          </div>
        </div>
      </div>
    </ScrollTrigger>
  );
}
